import React, {useState, useRef, useEffect, Fragment} from 'react';
import SliderRegistriTemplates from '../SliderRegistriTemplates'
import { useStateContext } from '../../context/StateContext';
import Divider from '../frontend_components/Divider';
import TrueFalseToggle from '../TrueFalseToggle';
import VisDiv from '../frontend_components/VisDiv';
import TextHighlight from '../frontend_components/TextHighlight';
import {FiEdit} from 'react-icons/fi'
import {AiFillCloseCircle} from 'react-icons/ai';
import NonConformityPin from '../NonConformityPin';
import SaveButton from '../frontend_components/SaveButton';
import { errorAlert, keyId, sortByLabel, successAlert, addValueForDropdown } from '../../lib/utils';
import { useCreateReplace } from '../../hooks/mutations';
import PromiseQueue from 'p-queue'
import Loading from '../Loading';
import { useQueryClient } from '@tanstack/react-query';
import FieldDropdown from '../FieldDropdown';
import { ReferencesArrayBox } from './ManagementModules';
import { referenceDoc, richEditorDoc } from '../gestioneDatabase/Docs';
import { v4 as uuidv4 } from 'uuid'; 
import { IoMdCloseCircle } from "react-icons/io";
import InsertNewSupplyCustomerProduct from '../InsertNewSupplyCustomerProduct';
import DeviceTemplatesManagement from './DeviceTemplatesManagement';
import InsertNewCustomerProduct from '../InsertNewCustomerProduct';
import { usePreventScroll } from 'react-aria';
import { IoIosArrowDropdown, IoIosArrowDropright } from 'react-icons/io';
import { useManagementContext } from '../../context/ManagementContext';
import TestButton from '../frontend_components/TestButton';



/**
 * Component that renders a management view for supply devices
 * #offerManagament
 * @param {Object} data - object containing data for the component
 * @returns {JSX.Element} - rendered component
 */
const SupplyDevices = ({data}) => {
    const {customer,  setLoading, } = useStateContext()
    const {newCustomerProduct, setNewCustomerProduct, newSupplyCustomerProduct, setNewSupplyCustomerProduct, newPresidioModule, setNewPresidioModule} = useManagementContext()
    
    usePreventScroll({isDisabled: newCustomerProduct?._id ? false : true})
    usePreventScroll({isDisabled: newPresidioModule?._id ? false : true})
    usePreventScroll({isDisabled: newSupplyCustomerProduct?._id ? false : true})
    //usePreventScroll({isDisabled: false})
   
    const{priceLists, templateRegisters, deviceProperties, lists, dataModules, laws, products, suppliers, customerProducts, presidioModules, nonConformities} = data
    const [registerTemplate, setRegisterTemplate] = useState()
    const[toggleEdit, setToggleEdit] = useState(false)
    const editSizeLeft = toggleEdit ? {width: "30%" } : {}
    const editSizeRight = toggleEdit ? {width: "70%" } : {}
    

/*     const supplyNonConformities = nonConformities?.filter?.((x)=>x?.supply)
 */    

const supplyNonConformity = !Array.isArray(nonConformities) ? undefined : nonConformities?.find?.((x)=>x?._id == registerTemplate?.supplyNonConformity?._ref)
const registerTemplateDevices = registerTemplate?.devices?.map?.((item)=> !Array.isArray(presidioModules) ? undefined : presidioModules?.find?.((y)=>y?._id == item?._ref))

/*     const supplyCustomerProductsToUpdate = !Array.isArray(customerProducts) ? [] : customerProducts?.filter?.((x)=>x?.supply)
 *//*     const updatedSupplyCustomerProducts = !Array.isArray(supplyCustomerProductsToUpdate) ? [] : supplyCustomerProductsToUpdate?.map?.((item)=>{
        const cmFilter = (x) => {
            const isInsupplyNonConformities = x?.nonConformities?.some?.((z)=> supplyNonConformities?.some?.(y=>y?._id == z?._ref))
            const bothHaveTemplateRegisters = x?.registers?.some?.((z)=> item?.registers?.some?.(y=>y?._ref == z?._ref))
            const isDeviceInProperties = x?.deviceProperties?.some?.((x)=>item?.deviceProperties?.some?.((y)=>y?._ref == x?._ref))
            const filterString = !x?.supply && !x?.maintenanceTask && x?.devices?.some?.((y)=>y?._ref == item?.devices?.[0]?._ref)
            if(x?.deviceProperties?.length) { return isDeviceInProperties && filterString && isInsupplyNonConformities && bothHaveTemplateRegisters}
            if(isInsupplyNonConformities && bothHaveTemplateRegisters && !x?.deviceProperties?.length && !x?.devices?.length) {return true}
            return filterString && isInsupplyNonConformities && bothHaveTemplateRegisters
        }
        const foundCustomerProducts = customerProducts?.filter?.(cmFilter)
        //const scpDoc = {...item, supplyCustomerProducts: foundCustomerProducts?.map?.((x)=>x)}
        const scpDoc = {...item, supplyCustomerProducts: foundCustomerProducts?.map?.((x)=>referenceDoc(x?._id))}
        return scpDoc
    }) */
/*     const subNonConformity = nonConformities?.find?.((x)=>x?._id == "5a6de70d-8353-4209-8eb9-cb62f5554d4a")
   const updatedSupplyCustomerProductsWithSubs = !Array.isArray(supplyCustomerProductsToUpdate) ? [] : supplyCustomerProductsToUpdate?.map?.((item)=>{
        const cmFilter = (x) => {
            //if(x?._id == "bcecf6be-7f8b-4780-a5a3-d3da2a70a5d0")console.log("dklqkdqwkd, base", x)
            //console.log("mdlamdlqkmdlakmdklawsmdx", x)
            const isInSubNonConformity = x?.nonConformities?.some?.((z)=> subNonConformity._id == z?._ref)
            
            const bothHaveTemplateRegisters = x?.registers?.some?.((z)=> item?.registers?.some?.(y=>y?._ref == z?._ref))
            const isDeviceInProperties = x?.deviceProperties?.some?.((x)=>item?.deviceProperties?.some?.((y)=>y?._ref == x?._ref))
            const filterString = !x?.supply && !x?.maintenanceTask && x?.devices?.some?.((y)=>y?._ref == item?.devices?.[0]?._ref)
            if(x?.deviceProperties?.length) { return isDeviceInProperties && filterString && isInSubNonConformity && bothHaveTemplateRegisters}
            if(isInSubNonConformity && bothHaveTemplateRegisters && !x?.deviceProperties?.length && !x?.devices?.length) {return true}
            return filterString && isInSubNonConformity && bothHaveTemplateRegisters

        }
        const foundCustomerProducts = customerProducts?.filter?.(cmFilter)
        //console.log("djqidqwiojdwd",foundCustomerProducts)
        //const scpDoc = {...item, supplyCustomerProducts: foundCustomerProducts?.map?.((x)=>x)}
        if(foundCustomerProducts?.length < 1) return
        const scpDoc = {...item, substitutionCustomerProducts: foundCustomerProducts?.map?.((x)=>referenceDoc(x?._id))}
        return scpDoc
    })?.filter((x)=>x) */
    const queryClient = useQueryClient()
    const {mutate: updateDocument} = useCreateReplace({
        onMutate: async (newDoc) => {

            await queryClient.cancelQueries({ queryKey: ['customerProductsReport'] })
            const previousCustomerProducts = queryClient.getQueryData(['customerProductsReport'])
       
            //const doc = newDoc?.doc
            
            queryClient.setQueryData(['customerProductsReport'], (old) =>{ 
                const doc = newDoc?.doc
                const oldData = old?.length > 0 ? old : []
                const newData = [...oldData?.filter?.(x=>x?._id!== doc._id), doc]          
                return newData
            })
            return { previousCustomerProducts }
        },
        onError: (err, newDoc, context) => {
            console.error('Oh no, the update failed: ', err?.message);
            errorAlert("Errore: il documento non é stato aggiornato")
        }
        })
        const createUpdateDocuments = async (docs) => {
            
            const queue = new PromiseQueue({
              concurrency: 12,
              intervalCap: 15,
              interval: 700,
            })
            for(const doc of docs) {
                //console.log("Document tested:", doc)
                 queue.add(() => {
                    return updateDocument({doc: doc})
                  })
            }      
        }
        const testFunction = () => {
            console.log("aòoweiejfòaweiojf",{ 
                //updatedSupplyCustomerProducts, 
                //updatedSupplyCustomerProductsWithCustomerProducts: updatedSupplyCustomerProducts?.filter?.((x)=>x?.customerProducts?.length),
                //withNoDevicesAssigned: updatedSupplyCustomerProducts?.filter?.((x)=>!x?.devices?.length),
                //withPropertuesAssigned: updatedSupplyCustomerProducts?.filter?.((x)=>x?.deviceProperties?.length),
                //supplyNonConformities,
                //updatedSupplyCustomerProductsWithSubs,
                //subNonConformity,
                //supplyCustomerProductsToUpdate,
                //priceLists
            })
            //createUpdateDocuments(updatedSupplyCustomerProductsWithSubs)
        }
  return (
    <div style={{}} className="split-view">
     <div className='new-device-container half-left' style = {{...editSizeLeft, overflow: "auto"}}>
            <h2>FORNITURA PRESIDI</h2>
            {/* <button onClick={testFunction}>update sub presidi</button> */}
            <VisDiv rules={[templateRegisters]}>
                <h4>FILTRA PER FAMIGLIA</h4>
                <SliderRegistriTemplates 
                    registerTemplateFilter={registerTemplate} 
                    setRegisterTemplateFilter={setRegisterTemplate} 
                    templates={!Array.isArray(templateRegisters) ? [] : templateRegisters?.filter?.((x)=>x?.customer?._ref == customer?._id)} 
                    setLoading={setLoading}
                />
            </VisDiv>
            <VisDiv rules={[registerTemplate]}>

                {registerTemplateDevices?.sort?.(sortByLabel)?.map?.((item, index)=>{
                    return(
                        <SupplyDevicePin 
                            toggleEdit={toggleEdit}
                            setToggleEdit={setToggleEdit}
                            setNewSupplyCustomerProduct={setNewSupplyCustomerProduct}
                            setNewPresidioModule={setNewPresidioModule}
                            setNewCustomerProduct={setNewCustomerProduct}
                            data={{deviceProperties, priceLists, templateRegisters, registerTemplate, supplyNonConformity, customer, customerProducts, device: item}} key={index}
                        />
                    )
                })}
            </VisDiv>
            <div style={{height: "900px"}}>
            </div>   

    </div>
      <VisDiv rules={[toggleEdit]} style = {{...editSizeRight}} className='new-device-container half-right'>
        <div style={{height: "80vh", display: "flex", flexDirection: "column"}} >
            <div className="titleCloseBtn">
                <button
                onClick={() => {
                    setToggleEdit(false);
                    setNewSupplyCustomerProduct(undefined);
                    setNewPresidioModule(undefined)
                    setNewCustomerProduct(undefined)
                    //console.log("close", {newSupplyCustomerProduct})
                }}
                 
                >
                <IoMdCloseCircle size={45}/>
                </button>
            </div>
            <VisDiv style={{height:"100%", width:"100%"}} rules={[newSupplyCustomerProduct]}>
                <InsertNewSupplyCustomerProduct data={{priceLists, hideCloseButton: true, customerProducts: customerProducts?.filter?.(x=>!x?.supply), supplyCustomerProducts: customerProducts?.filter?.(x=>x?.supply), nonConformities, templateRegisters, presidioModules, deviceProperties, lists, dataModules, laws, products, suppliers }}/>
            </VisDiv>
            <VisDiv style={{ height:"100%", width:"100%"}} rules={[newPresidioModule]}>
                <DeviceTemplatesManagement data={{templateRegisters, hideCloseButton: true, presidioModules}}/>
            </VisDiv>
            <VisDiv style={{height:"100%", width:"100%"}} rules={[newCustomerProduct]}>
                <InsertNewCustomerProduct data={{priceLists, hideCloseButton: true, customerProducts: customerProducts?.filter?.(x=>!x?.supply), supplyCustomerProducts: customerProducts?.filter?.(x=>x?.supply), nonConformities, templateRegisters, presidioModules, deviceProperties, lists, dataModules, laws, products, suppliers }}/>
            </VisDiv>

        </div>

      </VisDiv>
    </div>
  )
}

export default SupplyDevices

export const SupplyDevicePin = ({toggleEdit, setToggleEdit, setNewSupplyCustomerProduct, setNewCustomerProduct,  setNewPresidioModule, data={}}) => {

    const {deviceProperties, supplyNonConformity, customerProducts, device, registerTemplate, templateRegisters, priceLists, customer} = data
    const supplyCustomerProducts = !Array.isArray(customerProducts) ? [] : customerProducts?.filter?.((x)=>x?.supply)
    const customerProductsInNonConformity = customerProducts?.filter?.((x)=>!x?.supply && x?.nonConformities?.some?.(y=>y?._ref == supplyNonConformity?._id))
    const deviceSupplyCustomerProducts = supplyCustomerProducts?.filter?.((x)=>x?.registers?.some?.((z)=> registerTemplate?._id == z?._ref) && x?.devices?.some?.((y)=>y?._ref == device?._id))
    const customerProductsForDevice = customerProducts?.find((x)=>x?.label?.includes(device?.labe))
    const queryClient = useQueryClient()
    const [showProducts, setShowProducts] = useState(false)
    useEffect(() => {
        setShowProducts(false)
    },[registerTemplate])

            const {mutate: updateDocument} = useCreateReplace({
            onMutate: async (newDoc) => {
    
                await queryClient.cancelQueries({ queryKey: ['customerProductsReport'] })
                const previousData = queryClient.getQueryData(['customerProductsReport'])
           
                //const doc = newDoc?.doc
                
                queryClient.setQueryData(['customerProductsReport'], (old) =>{ 
                    const doc = newDoc?.doc
                    const oldData = old?.length > 0 ? old : []
                    const newData = [...oldData?.filter?.(x=>x?._id!== doc._id), doc]          
                    return newData
                })
                return {previousData}
            },
    
            onError: (err, newDoc, context) => {
                console.error('Oh no, the update failed: ', err?.message)
                errorAlert("ERRORE; Il documento non è stato modificato Ricarica la pagina")
                
                //queryClient.setQueryData(['customerProductsReport'], context?.previousData)
    
            }
            })

    const testFunction = () => {
        console.log("òowejfòaowejf",{
            device, 
            deviceSupplyCustomerProducts, 
            customerProductsInNonConformity,
            supplyCustomerProducts,
            customerProductsForDevice
        })
    }
    const createSupplyCustomerProduct = () => {

        
        const newCustomerProduct = {
                _type: "customerProduct",
                _id: uuidv4(),
                _key: keyId(),
                label: device?.label,
                customerProductCode:"",
                customer: referenceDoc(customer?._id),
                nonConformities: [{_ref: supplyNonConformity?._id, _type: "reference", _key: keyId()},  
                {
                    "_key": "d81453c9ae46433e81ca0ff87b65d896",
                    "_ref": "26087243-a363-46a4-888f-c609f35bf8be",
                    "_type": "reference"
                },
                {
                    "_key": "381eb97d8460431e9726b1fd1e268369",
                    "_ref": "67d4f994-8e34-4294-bf02-81988ad2b311",
                    "_type": "reference"
                },
                {
                    "_key": "0f132bba003c420092f1169062903ee3",
                    "_ref": "31bb5454-3cdf-4df1-ae62-7beb7943f78b",
                    "_type": "reference"
                },
                ],
                registers: [{_ref: registerTemplate?._id, _type: "reference", _key: keyId()}],
                devices: [{_ref: device?._id, _type: "reference", _key: keyId()}],
                devicesExclude:false,
                deviceProperties: [],
                propertiesExclude: false,
                unit: 1,
                labourHours: 0.5,
                specialisedLabour: false,
                addFormulario: false,
                isSign: false,
                supply: true,
                substitution: false,
                maintenanceTask: false,
                allowZero: false,
                details: richEditorDoc(""),
                hideNonConformityDescription: false,
                supplyCustomerProducts: [],
                substitutionCustomerProducts:[],
                law: referenceDoc(""),
                supplierProducts: []
        
            }
        if(!Array.isArray(device?.templates) || device?.templates?.length < 1) {
            errorAlert("ERRORE; Il dispositivo non ha registri template")
            return
        }
        console.log({newCustomerProduct})
        updateDocument({doc: newCustomerProduct})

    }
    const goToEditPresidioModule = () => {
        setToggleEdit(true)
        setNewPresidioModule(device)
    }
    const icon = () => {
        const size = 25
        if(!showProducts) return <IoIosArrowDropright size={size}/>
        return <IoIosArrowDropdown size={size}/>
    }
    const pinBackground = deviceSupplyCustomerProducts?.length > 0 ? "#f1f0ef" : "#AF7C7B"
    return (
        <div style={{borderRadius:"10px", backgroundColor: pinBackground, padding:"10px", marginBottom:"25px"}}>
            {/* <button onClick={testFunction}>test presidio module</button> */}

           
            <div style={{margin:"10px 0px 10px 0px", display:"flex", alignItems:"center"}}>
                <VisDiv rules={[!toggleEdit]} style={{display:"flex", alignItems:"center"}}>
                    <button type='button' className='round-back-button' style={{backgroundColor:"red",marginRight:"25px"}} onClick={goToEditPresidioModule}>
                        <FiEdit              
                        size={15}
                        color={"white"}/>
                    </button>
                </VisDiv>
                <h3>PRESIDIO: {device?.label}</h3>
                <div style={{marginLeft:"15px"}} onClick={() => setShowProducts(!showProducts)}>{icon()}</div>

            </div>
            <VisDiv rules={[showProducts]}>
                <VisDiv>
                    <button className="pdf-button" onClick={createSupplyCustomerProduct}>CREA PRODOTTO FORNITURA</button>
                </VisDiv>
                {customerProductsForDevice?.map((x)=>x?.label)}
                <VisDiv rules={[deviceSupplyCustomerProducts?.length > 0]}>
                    <div style={{margin:"10px 0px 10px 0px"}}>
                    <p>Prodotti Interni Fornitura:</p>
                    </div>
                    
                    {deviceSupplyCustomerProducts?.sort?.(sortByLabel)?.map?.((item, index)=>{
                        return(
                            <CustomerProductPin
                                setNewSupplyCustomerProduct = {setNewSupplyCustomerProduct}
                                setNewCustomerProduct={setNewCustomerProduct}
                                toggleEdit={toggleEdit}
                                setToggleEdit={setToggleEdit}
                                updateDocument={updateDocument} 
                                data={{allDeviceProperties: deviceProperties, priceLists, device, templateRegisters, registerTemplate, customerProductsInNonConformity, supplyNonConformity, customerProducts, supplyProduct: item}} key={index}
                            />
                        )
                    })}
            </VisDiv>
        </VisDiv>

        </div>
    )
}

export const CustomerProductPin = ({toggleEdit, setToggleEdit, setNewSupplyCustomerProduct, setNewCustomerProduct, updateDocument = () => {}, data={}}) => {
    const {allDeviceProperties, customerProductsInNonConformity,  registerTemplate, templateRegisters, priceLists, customerProducts, device, supplyNonConformity, supplyProduct} = data
    const [customerProductToEdit, setCustomerProductToEdit] = useState(supplyProduct)
    const [showAllProducts, setShowAllProducts] = useState(false)
    const [visibleTab, setVisibleTab] = useState("supply")
    

    const showProduct = (customerProduct={}) =>  {
        const {deviceProperties, devices} = customerProduct
        if(!customerProduct?._id) return undefined
        if(!deviceProperties && !devices) return customerProduct?.label
        if(deviceProperties?.length < 1 && devices?.length < 1) return customerProduct?.label

        if(deviceProperties?.length < 1 && devices?.length > 0) {
            const isDeviceInProduct = devices?.some?.((x)=>x?._ref == device?._id)
            if(isDeviceInProduct) return customerProduct?.label
            return undefined
        }
        if(deviceProperties?.length  > 0 && devices?.length < 1) {
            const isDeviceInProperties = deviceProperties?.some?.((x)=>customerProductToEdit?.deviceProperties?.some?.((y)=>y?._ref == x?._ref))
            if(isDeviceInProperties) return customerProduct?.label
            return undefined
        }
        if(deviceProperties?.length  > 0 && devices?.length > 0){
            const isDeviceInProduct = devices?.some?.((x)=>x?._ref == device?._id)
            const isDeviceInProperties = deviceProperties?.some?.((x)=>customerProductToEdit?.deviceProperties?.some?.((y)=>y?._ref == x?._ref))
            if(isDeviceInProduct && isDeviceInProperties) return customerProduct?.label
            return undefined
        }
        return undefined
    }
    const productsToShow1 = customerProductsInNonConformity?.map?.(x=>showProduct(x))?.filter?.(y=>y)

    const productsToShow = !Array.isArray(customerProductToEdit?.supplyCustomerProducts) ? [] : customerProductToEdit?.supplyCustomerProducts?.map?.((x)=>{
        const findProduct = customerProducts?.find?.((y)=>y?._id == x?._ref)
        return findProduct
    })
    
    // ADD PRODUCT TO SUPPLY PRODUCT

    const customerProductsOptions = !Array.isArray(customerProducts) ? [] : customerProducts?.filter?.(x=>!x?.supply)?.map?.((item)=>({...item, value: item?.label}))
    
    const isSupplyNonConformityPresent = customerProductToEdit?.nonConformities?.some?.((x)=>x?._ref == supplyNonConformity?._id)
    const isRegisterTemplatePresent = customerProductToEdit?.registers?.some?.((x)=>x?._ref == registerTemplate?._id)
    const areAnyDevicesPresent = customerProductToEdit?.devices?.length > 0
    const areAnyPropertiesPresent = customerProductToEdit?.deviceProperties?.length > 0

    useEffect(()=>{
        if(customerProductToEdit){
            //console.log({customerProductToEdit, isSupplyNonConformityPresent, areAnyDevicesPresent, areAnyPropertiesPresent, isRegisterTemplatePresent})
            setCustomerProductToEdit(supplyProduct)
        }
    },[supplyProduct])
    
    const defaultPriceList = priceLists?.find?.((x)=>x?.default)
    const isInPriceList = defaultPriceList?.products?.some?.((x)=>x?.customerProduct?._ref == customerProductToEdit?._id)
    const addSupplyProductTest = () =>  {
        console.log({supplyProduct, customerProductToEdit, defaultPriceList})
      
    }

    const saveSupplyProduct = (data) => {
        //console.log("gsquywsgqwuys", data)
        setCustomerProductToEdit(data)
        updateDocument({doc: data})
    }
    const goToEditProduct = () => {
        console.log("go to edit product")
        setNewSupplyCustomerProduct(supplyProduct)
         setToggleEdit(!toggleEdit)
    }
    const supplyCustomerProductReferenceData = {type: "referenceArray", hideFilter:true, data: customerProducts, propertyName: "supplyCustomerProducts", filterAddById: showAllProducts ? undefined : registerTemplate?._id, filterAddKey: "registers", registerTemplate, checkRegisterTemplate: true, registerTemplateKey: "registers", }
    const substitutionCustomerProductReferenceData = {type: "referenceArray", hideFilter:true, data: customerProducts, propertyName: "substitutionCustomerProducts", filterAddById: showAllProducts ? undefined : registerTemplate?._id, filterAddKey: "registers", registerTemplate, checkRegisterTemplate: true, registerTemplateKey: "registers", }

    const editDocument = (doc) => {
        const findCustomerProduct = customerProducts?.find?.((x)=>x?._id == doc?._id)
        console.log("kjdkqwjdn edit doc",{doc, findCustomerProduct})
        if(!findCustomerProduct && doc?._type == "customerProduct") 
            {
                setNewCustomerProduct(doc);
                setToggleEdit(!toggleEdit);
            }
        if(findCustomerProduct) {
            setNewCustomerProduct(findCustomerProduct);
            setToggleEdit(!toggleEdit);
        }
        
    }
    //console.log("lkasmdlkasjdlaksdj", customerProductToEdit)
    const newEmptyDoc = () => ({
        _type: "customerProduct",
        _id: uuidv4(),
        _key: keyId(),
        label: "Nuovo Prodotto",
        customerProductCode:"",
        customer: customerProductToEdit?.customer,
        nonConformities: [],
        registers: customerProductToEdit?.registers,
        devices: [],
        devicesExclude:false,
        deviceProperties: [],
        propertiesExclude: false,
        unit: 1,
        labourHours: 0.5,
        specialisedLabour: false,
        addFormulario: false,
        isSign: false,
        supply: false,
        substitution: false,
        maintenanceTask: false,
        allowZero: false, 
        details: richEditorDoc(""),
        hideNonConformityDescription: false,
        law: referenceDoc(""),
        supplierProducts: []

    })
    const consoleData = {customerProductToEdit, supplyCustomerProductReferenceData}
    return (
        <div style={{borderRadius:"10px",border:"2px solid grey", backgroundColor:"white", padding:"10px", marginBottom:"5px"}}>
            <div>
                <TestButton buttonId='wpokdpqkdpoqwk' message='test pir' consoleData={consoleData}/>
                <TrueFalseToggle 
                    value={showAllProducts} 
                    onClick={() =>  setShowAllProducts(!showAllProducts)} 
                    label="Mostra tutti i prodotti" 
                />
                <VisDiv rules={[!toggleEdit]} style={{display:"flex", alignItems:"center", marginTop:"10px", marginBottom:"10px"}}>
                    <button type='button' className='round-back-button' style={{backgroundColor:"red",marginRight:"25px"}} onClick={goToEditProduct}>
                        <FiEdit              
                        size={15}
                        color={"white"}/>
                    </button>
                    <h4 onClick={addSupplyProductTest}>{customerProductToEdit?.label}</h4>
                </VisDiv>

                <div style={{padding:"10px"}}>
                    <VisDiv style={{marginBottom:"13px"}} rules={[customerProductToEdit?.deviceProperties?.length > 0]}>
                        {customerProductToEdit?.deviceProperties?.map?.((item, index)=>{
                            const findProperty = allDeviceProperties?.find?.((x)=>x?._id == item?._ref)
                            return (
                                <TextHighlight  style={{marginRight:"5px"}} highlight="blue" key={index}>{findProperty?.label}</TextHighlight>
                                    
                            )
                        })}
                    </VisDiv>
                    <VisDiv style={{color:"red", }} rules={[supplyProduct?.supplierProducts?.length < 1]}>
                        <TextHighlight style={{marginRight:"5px"}} highlight="red">MANCA PRODOTTO FORNITORE</TextHighlight>
                    </VisDiv>
                    <VisDiv style={{color:"orange", marginTop:"13px"}} rules={[!isInPriceList]}>
                        <TextHighlight style={{marginRight:"5px"}} highlight="amber">MANCA PREZZO LISTINO</TextHighlight>
                    </VisDiv>
{/*                     <VisDiv style={{marginTop:"10px"}} rules={[productsToShow?.length > 0]}>
                        <p>Prodotti Associati:</p>
                        {productsToShow?.map?.((product, index)=>{
                            return (
                                <div key={index}>
                                    <p>{product?.label}</p>
                                </div>
                            )
                        })}
                    </VisDiv> */}
{/*                     <FieldDropdown
                        isSearchable="isSearchable"
                        options={customerProductsOptions}
                        onChange={(value) => setCustomerProductToEdit(value)}
                        placeHolder={"SELEZIONA PRODOTTO DA AGGIUNGERE"}
                    /> */}
                    <div style={{cursor:"pointer", height: "50px", display:"flex", alignItems:"center", color:"white", backgroundColor:"#324d67"}}>
                        <VisDiv onClick={()=>setVisibleTab("supply")}  style={{ height: "50px", flex: 1, display:"flex", alignItems:"center", justifyContent:"center", backgroundColor: visibleTab == "supply" && "white", color:visibleTab == "supply" && "white"}} rules={[]}>
                            <h3 style={{color: visibleTab == "supply" && "#324d67",}}>PRODOTTI FORNITURA</h3>
                        </VisDiv>
                        <VisDiv onClick={()=>setVisibleTab("substitution")}  style={{height: "50px", flex: 1, display:"flex", alignItems:"center", justifyContent:"center", backgroundColor:visibleTab == "substitution" && "white", color:visibleTab == "substitution" && "white"}} rules={[]}>
                             <h3 style={{color: visibleTab == "substitution" && "#324d67",}}>PRODOTTI SOSTITUZIONE</h3>             
                        </VisDiv> 
                    </div>
                    <VisDiv style={{marginTop:"15px"}} rules={[customerProductToEdit, visibleTab == "supply"]}>
                        {/* <button onClick={addSupplyProductTest}>test cp to edit</button> */}
                        <p>Prodotti Fornitura Associati:</p>
                        <ReferencesArrayBox 
                            doc={customerProductToEdit} 
                            showFornituraIcon={true}
                            setDoc={saveSupplyProduct} 
                            referenceData={supplyCustomerProductReferenceData}
                            query={['customerProductsReport']}
                            newEmptyDoc = {newEmptyDoc()}
                            editDocument={editDocument}
                        />
                    </VisDiv>
                    <VisDiv style={{marginTop:"15px"}} rules={[customerProductToEdit, visibleTab == "substitution"]}>
                        {/* <button onClick={addSupplyProductTest}>test cp to edit</button> */}
                        <p>Prodotti Sostituzione Associati:</p>
                        <ReferencesArrayBox 
                            showFornituraIcon={true}
                            doc={customerProductToEdit} 
                            setDoc={saveSupplyProduct} 
                            referenceData={substitutionCustomerProductReferenceData}
                            query={['customerProductsReport']}
                            newEmptyDoc = {newEmptyDoc()}
                            editDocument={editDocument}
                        />
                    </VisDiv>
                </div>

            </div>
        </div>
    )
}